var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon",class:_vm.classes},[_c('use',{attrs:{"xlink:href":_vm.iconPath}})])
}
var staticRenderFns = []

export { render, staticRenderFns }